import { render, staticRenderFns } from "./VatSetupList.vue?vue&type=template&id=7b2c3a1c&scoped=true&"
import script from "./VatSetupList.vue?vue&type=script&lang=js&"
export * from "./VatSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c3a1c",
  null
  
)

export default component.exports